
import { Helmet } from "react-helmet"
import { MetaSettings } from "./metaSettings"

interface Props{
  path:string
}

const MetaTags = (props:Props)=>{
  const getTitle = (path: string): string => {
    // Сначала пытаемся найти точное совпадение
    if (MetaSettings[path as keyof typeof MetaSettings]) {
      return MetaSettings[path as keyof typeof MetaSettings].title;
    }

    // Если точного совпадения нет, ищем по частям пути
    // Например, для "/services/racket-calendar/something" будем искать:
    // "/services/racket-calendar/something" -> "/services/racket-calendar" -> "/racket-calendar"
    const pathParts = path.split('/').filter(Boolean);
    
    for (let i = pathParts.length; i > 0; i--) {
      const testPath = '/' + pathParts.slice(0, i).join('/');
      if (MetaSettings[testPath as keyof typeof MetaSettings]) {
        return MetaSettings[testPath as keyof typeof MetaSettings].title;
      }
    }

    // Если ничего не найдено, возвращаем дефолтный title
    return 'Клуб Tennis.ru';
  }

  const title = getTitle(props.path);

  return(
    <Helmet>
      <title>Клуб Tennis.ru - {title}</title>
    </Helmet>
  )
}
export default MetaTags
